export default __webpack_public_path__ + "static/media/cladding33.47c2c981.jpeg";